
































import { Component, Vue } from 'nuxt-property-decorator'
import BlogItem from '~/components/Blog/BlogItem.vue'
import { getItemsByLang } from '~/data/blogs/conversion'
import { createHead } from '~/helpers/SeoUtils'
import * as PostsUtils from '~/utils/PostsUtils'
import PostItem from '~/components/Post/PostItem.vue'

@Component({
  name: 'BlogItemPage',
  components: { PostItem }
})
export default class extends Vue {
  head() {
    if (this.item)
      return createHead({
        Title: this.item.Title,
        UseDefaultTitlePostfix: true
      })
  }

  item = null
  password = ''
  show = true

  async asyncData({ params, query, app, $axios, $i18n, error }) {
    const language = PostsUtils.getLangToLoadByLocale(app.i18n._vm._data.locale)
    const post = await $axios.$get(`/api/posts/Blog/${language}/${params.slug}`)
    if (post) {
      if (post.Visibility === 'Password Protected') {
        return {
          item: post,
          show: false
        }
      } else {
        return {
          item: post,
          show: true
        }
      }
    } else {
      error({ statusCode: 404, message: 'Page not found' })
    }
  }

  get slug() {
    return this.$route.params.slug
  }

  async handleSubmit() {
    const language = PostsUtils.getLangToLoadByLocale(this.$i18n.locale)
    const post = await this.$axios.$get(
      `/api/posts/Blog/${language}/${this.slug}`,
      {
        params: {
          pass: this.password
        }
      }
    )
    if (post) {
      if (post.BodyBlocks !== null) {
        this.item = post
        this.show = true
      } else {
        this.item = post
        this.show = false
      }
    }
  }

  // get item() {
  //   const item = getItemsByLang(this.$i18n.locale).find(
  //     (item) => item.Id + '-' + item.Slug === this.slug
  //   )
  //   return (
  //     item || this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
  //   )
  // }
}
